import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const SortWorkAreasButton = () => {
  return (
    <Box flexDirection="row" width="full" alignItems="center" gap="s0">
      <Box flexDirection="row" width="full">
        <Text size="200" weight="medium" className="text-f1-foreground-secondary">
          {i18n.t('shift_management.view_by_area.header_cell')}
        </Text>
      </Box>
    </Box>
  )
}

export {SortWorkAreasButton}
